module.exports = __webpack_public_path__ + "static/media/bitcoin.14fe0a5a.svg";